export const iconFontAwesomeHouseholdPeopleRoof = (
	<i className="fa-solid fa-people-roof"></i>
);
